<template>
<div>
	<v-content>
		<v-container fluid>     			
          <v-flex xs3>
            <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
          </v-flex>
			<v-data-table :headers="headers" :search="search" :items="specList" class="elevation-1" disable-initial-sort style="font-size: 10px;"  :rows-per-page-items="[20,40,60,80,100]">
				<template slot="items" slot-scope="props">  
                    <td width="100px" class="text-xs-right"><a @click.prevent="fncViewQuote(props.item)"><i class="material-icons">view_quilt</i></a></td>
					<td class="text-xs-right" v-for="item in objQuoteSettings" :width="fncGetWidth(item.id)" v-if="item.checked"><a v-if="item.id == 'status'" href="#" @click.prevent="fncEditStatusPopup(props.item, props.item.id)"><i class="material-icons">edit</i></a><span @click.prevent="fncEditStatus(props.item,item.id)" v-html="fncFormatColumn(props.item,item.id)"></span></td>
                    <td width="100px" class="text-xs-right"><a @click.prevent="fncForex(props.item.id, props.item.quote_no, props.item.override_currency_code)"><i class="material-icons">attach_money</i></a></td>
                    <td width="100px" class="text-xs-right"><a @click.prevent="fncQuoteSettings(props.item.id, props.item.quote_no)"><i class="material-icons">settings</i></a></td>
					<td width="100px" class="text-xs-right"><a @click.prevent="fncDistibuteQuote(props.item.id)"><i class="material-icons">message</i></a></td>
				</template>
			</v-data-table>
		</v-container>
	</v-content>
</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
	name: 'SpecList',
    data () {
		return {
			search: '',
            headers: [],
            columnLengths: [],
            objCustomerRegion: window.localStorage.qRegion != undefined && window.localStorage.qRegion[0] != null ? window.localStorage.qRegion.split(',') : '',
            objOriginator: window.localStorage.qOriginator != undefined && window.localStorage.qOriginator[0] != null ? window.localStorage.qOriginator.split(',') : '',
            objStatus: window.localStorage.qStatus != undefined && window.localStorage.qStatus[0] != null ? window.localStorage.qStatus.split(',') : '',
            objCustomerCompany: window.localStorage.qCompany != undefined && window.localStorage.qCompany[0] != null ? window.localStorage.qCompany.split(',') : '',
            objCustomerUser: window.localStorage.qCustomer != undefined && window.localStorage.qCustomer[0] != null ? window.localStorage.qCustomer.split(',') : '',
            objProject: window.localStorage.qProject != undefined && window.localStorage.qProject[0] != null ? window.localStorage.qProject.split(',') : '',
            objSpecifier: window.localStorage.qSpecifier != undefined && window.localStorage.qSpecifier[0] != null ? window.localStorage.qSpecifier.split(',') : '',            
            startDate: window.localStorage.qStartDate,
            endDate: window.localStorage.qEndDate
		}
	},
    methods: {
      fncGetWidth(columnId) {
        var setWidth = '';
        for (var k in this.objQuoteSettings) {
          if (this.objQuoteSettings[k].id == columnId) {
            setWidth = this.objQuoteSettings[k].width;
          }
        }
        if (setWidth == 'auto') {
          setWidth = '200px';
        }
        return setWidth;
      },
      fncFormatColumn(objItem, key) {        
			switch(key) {
              case 'sub_total':                
                return this.fncFixedRand(objItem.pricing_subtotal, objItem.currency_sym);
					break;
				case 'vat':
                return this.fncFixedRand(objItem.pricing_vat, objItem.currency_sym);
					break;
				case 'total':
                return this.fncFixedRand(objItem.pricing_total, objItem.currency_sym);
					break;
				case 'discount_value':
                return this.fncFixedRand(objItem.discount_val, objItem.currency_sym);
					break;
				case 'customer_region':
					return this.fncCheckNull(objItem.customer_region);
					break;
				case 'originator_region':
					return this.fncCheckNull(objItem.originator_region);
					break;
				case 'status':
					return '<strong class="cursor">&nbsp;'+objItem.status+'</strong>';
					break;
				case 'orig_name':
					return '<strong class="cursor">'+objItem.orig_name+'</strong>';
					break;
				case 'responsible_representative':
					return '<strong class="cursor">'+objItem.responsible_representative+'</strong>';
                    break;
                case 'customer_name':
                  return '<strong class="cursor">' + objItem.customer_name + '</strong>';
                  break;
				default:
					return objItem[key];
					break;
			}
		},
      fncFixedRand(val, currencySymbol) {
            if ( currencySymbol == '' || currencySymbol == null ) {
              currencySymbol = 'R';
            }
			return currencySymbol + parseFloat(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		  },
		fncCheckNull(val) {
			if( val === null ) {
				return 'N/A';
			} else {
				return '<span class="cursor">' + val + '</span>';
			}
		},
		fncShowColumn(col){
			console.log(col);
		},
		fncEditStatus(objItem, key) {
          if (key === 'status') {
            this.$store.dispatch('fncGetQuoteHistory', objItem.id);
            var modalDetails = { title: 'Status History', component: 'modal-quote-history', mstate: true, params: {} };
            this.$store.commit({
              type: 'setModal',
              details: modalDetails
            });
          } else if (key === 'orig_name' || key === 'originator_region') {
            this.$store.dispatch('fncGetUserInfo', objItem.originator);
            var modalDetails = { title: 'User Information', component: 'modal-user-info', mstate: true, params: {} };
            this.$store.commit({
              type: 'setModal',
              details: modalDetails
            });
          } else if (key === 'customer_name' || key === 'customer_region') {
            this.$store.dispatch('fncGetUserInfo', objItem.customer);
            var modalDetails = { title: 'User Information', component: 'modal-user-info', mstate: true, params: objItem.customer };
            this.$store.commit({
              type: 'setModal',
              details: modalDetails
            });
          } else if (key === 'responsible_representative') {  
            var modalDetails = { title: 'Link / Unlink Users', component: 'modal-quote-link-users', mstate: true, params: { quoteId: objItem } };
            this.$store.commit({
              type: 'setModal',
              details: modalDetails
            });
            this.$store.dispatch('fncAvailableReps', objItem.customer_id);
          }
		},
        fncEditStatusPopup( status, quoteId ) {
            var modalDetails = { title: 'Quote Status Update', component: 'modal-quote-status-update', mstate: true, params: {currentStatus: status.status, quoteId: quoteId, currentStatusStatic: status.status } };
            this.$store.dispatch('fncPopulateStatusList');
            this.$store.commit({
                type: 'setModal',
                details: modalDetails
            });
		},
        fncDistibuteQuote( objItem ) {
            var modalDetails = { title: 'Generate Quote', component: 'modal-distribute-quote', mstate: true, params: {quoteId: objItem} };
            this.$store.commit({
                type: 'setModal',
                details: modalDetails
            });
        },
        fncQuoteSettings(quoteId, quoteNo) {
          this.$store.dispatch({
            type: 'fncQuoteSettings',
            quoteId: quoteId,
            quoteNo: quoteNo
          })
          //this.$store.dispatch('fncQuoteSettings', quoteId);
        },
        fncForex(quoteId, quoteNo, currencyType) {
          var modalDetails = { title: 'Change Curreny - '+quoteNo, component: 'modal-quote-forex', mstate: true, params: { quoteId: quoteId, currencyType: currencyType } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        },
        fncViewQuote( quoteItem ) {
          this.$store.dispatch('fncViewAppQuote', quoteItem);
        }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'specList',
			'spinePriceList',
			'objQuoteSettings'
		])
	},
    beforeMount() {
      this.$store.dispatch({
        type: 'fncPopulateSpecList'        
      })
      // this.$store.dispatch('fncSpinePriceList');

      //console.log(this.headers);
      //if (this.headers.length !== 0) {
      this.headers = [];          
      this.headers.push({ text: 'View Quote', value: 'view', width: '100px' });
        for (var k in this.objQuoteSettings) {
          if (this.objQuoteSettings[k].checked === true) {
            var headerWidth = this.objQuoteSettings[k].width == 'auto' ? '200px' : this.objQuoteSettings[k].width;                
            var objHeader = { text: this.objQuoteSettings[k].label, value: this.objQuoteSettings[k].id, width: headerWidth };
            this.headers.push(objHeader);
          }
        }
        this.headers.push({ text: 'Forex', value: 'forex', width: '100px' });
        this.headers.push({ text: 'Settings', value: 'settings', width: '100px' });
        this.headers.push({ text: 'Distribute', value: 'distribute', width: '100px' });        
      //}
	},
	watch: {	
	}
}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>